import { c as _c } from "react/compiler-runtime";
import React, { useState, useEffect } from 'react';

/**
 * TypingText component that creates a typewriter effect
 * @param {string} text - The text to display with typewriter effect
 * @param {number} typingSpeed - Speed of typing in milliseconds
 * @param {boolean} loop - Whether to loop the typing effect
 * @param {number} loopDelay - Delay before restarting the loop in milliseconds
 * @returns {JSX.Element} - The component with typewriter effect
 */
const TypingText = t0 => {
  const $ = _c(13);
  const {
    text,
    typingSpeed: t1,
    loop: t2,
    loopDelay: t3
  } = t0;
  const typingSpeed = t1 === undefined ? 50 : t1;
  const loop = t2 === undefined ? false : t2;
  const loopDelay = t3 === undefined ? 1000 : t3;
  const [displayText, setDisplayText] = useState("");
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isTyping] = useState(true);
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      setDisplayText("");
      setCurrentIndex(0);
    };
    $[0] = t4;
  } else {
    t4 = $[0];
  }
  let t5;
  if ($[1] !== text) {
    t5 = [text];
    $[1] = text;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  useEffect(t4, t5);
  let t6;
  let t7;
  if ($[3] !== currentIndex || $[4] !== isTyping || $[5] !== loop || $[6] !== loopDelay || $[7] !== text || $[8] !== typingSpeed) {
    t6 = () => {
      let timer;
      if (isTyping) {
        if (currentIndex < text.length) {
          timer = setTimeout(() => {
            setDisplayText(prev => prev + text[currentIndex]);
            setCurrentIndex(_temp);
          }, typingSpeed);
        } else {
          if (loop) {
            timer = setTimeout(() => {
              setDisplayText("");
              setCurrentIndex(0);
            }, loopDelay);
          }
        }
      }
      return () => clearTimeout(timer);
    };
    t7 = [currentIndex, text, typingSpeed, loop, loopDelay, isTyping];
    $[3] = currentIndex;
    $[4] = isTyping;
    $[5] = loop;
    $[6] = loopDelay;
    $[7] = text;
    $[8] = typingSpeed;
    $[9] = t6;
    $[10] = t7;
  } else {
    t6 = $[9];
    t7 = $[10];
  }
  useEffect(t6, t7);
  let t8;
  if ($[11] !== displayText) {
    t8 = <span>{displayText}</span>;
    $[11] = displayText;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  return t8;
};
export default TypingText;
function _temp(prev_0) {
  return prev_0 + 1;
}